var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinancialCents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#financial-cents_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#001A31",
  d: "M42.955 14.27H20.239v4.451h22.716zM31.643 29.637H20.27v4.452h11.373zM42.955 21.953H20.239v4.452h22.716z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#259245",
  d: "m40.668 44.913-8.964 9.025-8.294-8.263-5.03 5.062L31.733 64l25.551-25.734V28.174L40.668 44.882z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#001A31",
  d: "m21.855 44.181-8.69-8.598V7.165l31.162-.03 5.824 5.824V32.32l7.134-7.135V10.001l-.731-.732L48.138.854 47.284 0 6 .061l.061 38.51 10.763 10.672 5.031-5.032z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "financial-cents_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));
export default SvgFinancialCents;